import React from 'react';
import { makeConnect } from '../../infrastructure/components/mobx-extensions';
import { RolesVM } from './roles.viewmodel';

const RolesContext = React.createContext<RolesVM>(null);
const connectRolesVM = makeConnect(RolesContext);

export { RolesContext, connectRolesVM };
